import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { IUser } from '../../../../../interfaces/user';
import { useFormatMessage } from '../../../../../hooks';
import { getUsers } from '../../../../../crud/users.crud';
import { getResponseMessage } from '../../../../../utils/utils';

export const useGetUsers = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [total, setTotal] = useState(0);
  const [users, setUsers] = useState<IUser[]>([]);
  const [err, setErr] = useState(false);
  const dispatch = useDispatch();
  const fm = useFormatMessage();

  const fetchUsers = useCallback(
    async (roles: string, page: number, per_page: number) => {
      setLoading(true);
      getUsers(roles, page, per_page)
        .then(res => {
          setTotal(res.data.total);
          setPage(res.data.page);
          setPerPage(res.data.per_page);
          setUsers(res.data.data);
        })
        .catch(e => {
          setErr(true);
          enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, { variant: 'error' });
        })
        .finally(() => {
          setErr(false);
          setLoading(false);
        });
    },
    [dispatch]
  );

  return { fetchUsers, loading, page, perPage, total, users, err };
};
